import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SkinFilledSvg from "@ant-design/icons-svg/es/asn/SkinFilled";
import AntdIcon from "../components/AntdIcon";
var SkinFilled = function SkinFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SkinFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SkinFilled.displayName = 'SkinFilled';
}
export default /*#__PURE__*/React.forwardRef(SkinFilled);